<template>
<div>
  <div>
    <v-btn color="green" @click='testOrderRequest()'>Test place order</v-btn>
    <span>{{ placeOrder }}</span>
  </div>
  <div>
    <v-btn color="green" @click='testListOrders()'>Test list orders</v-btn>
    <span>{{ listOrders }}</span>
  </div>
  <div>
    <v-btn color="green" @click='testListOrderDetails'>Test list order details</v-btn>
    <span>{{ listOrderDetails }}</span>
  </div>
  <div>
    <v-btn color="green" @click='testTTSCharactersBalance'>Get TTS characters balance of user</v-btn>
    <span>{{ ttsCharactersBalance }}</span>
  </div>
  <div>
    <v-btn color="green" @click='testUserFeedback'>Test place user feedback</v-btn>
    <span>{{ userFeedback }}</span>
  </div>
  <paypal >
  </paypal>
</div>
</template>

<script>
//Import the Amazon S3 service client
var S3 = require("aws-sdk/clients/s3");
var AWS = require("aws-sdk/global");

import { Auth } from "./auth/cognito_auth";
import paypal from "./PayPal";

var Lambda = require("aws-sdk/clients/lambda");
// create variable to hold data returned by the Lambda function
//var pullResults = 'some message';
export default {
  name: "AudioTest",
  data: function() {
    return {
      placeOrder: "",
      listOrders: "",
      listOrderDetails: "",
      ttsCharactersBalance: "",
      userFeedback: ""
    };
  },
  components: {
    paypal
  },
  methods: {
    testUserFeedback: function() {
      var that = this;
      AWS.config.credentials.getPromise().then(
        function() {
          // Set credentials and region
          var uploadFunction = new Lambda();
          var id_token = Auth.getIdToken();

          var payload = JSON.stringify({
            //this is sample payload
            comment: "User feedback text...",
            idToken: id_token,
            rating: "5.0"
          });

        // create JSON object for parameters for invoking Lambda function
        var pullParams = {
          FunctionName: process.env.VUE_APP_AWS_LAMBDA_FEEDBACK_ARN,
          InvocationType: 'Event',
          Payload: payload
        };

          that.userFeedback = "Invoking...";

          uploadFunction.invoke(pullParams, function(error, data) {
            if (error) {
              prompt(error);
            } else {
              that.userFeedback = "Completed! " + JSON.stringify(data);
            }
          });
        },
        function(err) {
          prompt(err);
        }
      );
    },

    testListOrderDetails: function() {
      // Set credentials and region
      var s3 = new S3();

      var params = {
        Bucket: "dev-lingoav-customer-projects",
        Delimiter: "/",
        Prefix:
          AWS.config.credentials.identityId + "/" + "2019-02-26T12.42.18.493/"
      };

      var that = this;
      s3.listObjectsV2(params, function(err, data) {
        if (err) {
          prompt(err); // an error occurred
        } else {
          that.listOrderDetails = data; // successful response
        }
      });
    },

    testListOrders: function() {
      // Set credentials and region
      var s3 = new S3();

      var params = {
        Bucket: process.env.VUE_APP_AWS_BUCKET_CUSTOMER_PROJECTS_BUCKET,
        Delimiter: '/',
        Prefix: AWS.config.credentials.identityId + '/'
      };

      var that = this;
      s3.listObjectsV2(params, function(err, data) {
        if (err) {
          prompt(err); // an error occurred
        } else {
          that.listOrders = data; // successful response
        }
      });
    },
    testOrderRequest: function() {
      // Set credentials and region
      var uploadFunction = new Lambda();
      var id_token = Auth.getIdToken();

      var payload = JSON.stringify({
        //this is sample payload
        text: "Text provided via input parameter",
        langugeCode: "en-US",
        voiceName: "en-US-Standard-B",
        audioEncodingEnum: "LINEAR16",
        resultFileName: "generated_voice",
        idToken: id_token
      });

      // create JSON object for parameters for invoking Lambda function
      var pullParams = {
        FunctionName: process.env.VUE_APP_AWS_LAMBDA_ORDER_ARN,
        InvocationType: 'RequestResponse',
        Payload: payload
      };

      var that = this;
      this.placeOrder = "Invoking...";

      uploadFunction.invoke(pullParams, function(error, data) {
        if (error) {
          prompt(error);
        } else {
          that.placeOrder = "Completed! " + JSON.stringify(data);
        }
      });
    }
  }
};
</script>
